import Button from "@/shared/form/button";
import { CheckOutlined } from "@ant-design/icons";
import { useTranslations } from "use-intl";

export function PopoverControls({
  onOk,
  onCancel = () => {},
}: {
  onOk: () => void;
  onCancel?: () => void;
}) {
  const t = useTranslations("AI");

  return (
    <>
      <Button size={"small"} onClick={onCancel}>
        {t("Cancel")}
      </Button>
      <Button
        type={"primary"}
        size={"small"}
        icon={<CheckOutlined />}
        iconPosition={"end"}
        onClick={onOk}
      >
        {t("Apply")}
      </Button>
    </>
  );
}
